import { Calendar, ExternalLink } from "lucide-react"

interface Article {
  title: string;
  subtitle: string;
  body: string;
  sourceUrl: string;
  generatedAt: string;
}

interface ArticlePreviewProps {
  article: Article;
}

export default function ArticlePreview({ article }: ArticlePreviewProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const formatBody = (body: string) => {
    // Split body into paragraphs and format quotes
    return body.split("\n\n").map((paragraph, index) => {
      if (paragraph.startsWith('"') && paragraph.endsWith('"')) {
        // This is a quote
        return (
          <blockquote
            key={index}
            className="article-preview__quote"
          >
            <p>{paragraph}</p>
          </blockquote>
        )
      }
      return (
        <p key={index}>
          {paragraph}
        </p>
      )
    })
  }

  return (
    <article className="article-preview">
      <header className="article-preview__header">
        <h1>{article.title}</h1>
        {article.subtitle && <p className="article-preview__subtitle">{article.subtitle}</p>}
        <div className="article-preview__meta">
          <span>
            <Calendar className="h-4 w-4" aria-hidden="true" />
            {formatDate(article.generatedAt)}
          </span>
          <a href={article.sourceUrl} target="_blank" rel="noopener noreferrer">
            <ExternalLink className="h-4 w-4" aria-hidden="true" />
            View source
          </a>
          <span>AI draft</span>
        </div>
      </header>
      <div className="article-preview__body">{formatBody(article.body)}</div>
      <footer className="article-preview__note">
        This draft was created from public Reddit content. Review names, quotes, and claims before publishing.
      </footer>
    </article>
  )
}
